export enum BookingType {
    SHARING = "sharing" ,
    CHARGING = "charging"
}
